<template>
  <div class="Tb_briefing_wrap">
    <form>
      <div class="setBox_wrap">
        <div id="market_type">
          <a :class="{ active: currentTab === 'am-brief' }" @click="tabChange('am-brief')">
            <!-- {{ $t("brief['am']") }} -->
              BTC
          </a>
          <a :class="{ active: currentTab === 'pm-brief' }" @click="tabChange('pm-brief')">
            <!-- {{ $t("brief['pm']") }} -->
              ALT
          </a>
          <!-- <a :class="{ active: currentTab === 'pick-brief' }" @click="tabChange('pick-brief')">
            {{ $t("brief['pick']") }}
          </a> -->
        </div>
      </div>
    </form>
  </div>

  <div v-show="currentTab === 'am-brief'">
    <component :is="tableComponent" boardType="am-brief" :boardList="boardList" />
  </div>
  <!-- <div v-show="currentTab === 'pick-brief'">
    <component :is="tableComponent" boardType="pick-brief" :boardList="boardList" />
  </div> -->
  <div v-show="currentTab === 'pm-brief'">
    <component :is="tableComponent" boardType="pm-brief" :boardList="boardList" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "AllBrief",
  props: {
    boardList: Array,
    tableComponent: {
      type: Object,
      required: true,
    },
  },
  components: {},

  computed: {
    ...mapState("board", ["currentTab"]),
  },
  methods: {
    ...mapMutations("board", ["changeTab", "changeLoadBrief"]),

    tabChange(tab) {
      this.changeTab(tab);
    },
  },
  watch: {
    currentTab(newVal, oldVal) {
      if (newVal != oldVal) {
        this.changeLoadBrief({ state: false })
      }
    }
  }
};
</script>
<style scoped>
#market_type a {
  min-width: 70px;
}
</style>
